module.exports = __webpack_public_path__ + "sunsemweb/img/1.a9877c50.png";